define([
	"dojo/_base/declare",
	"SiteAdmin/AttributeMap/MappedAttributeId"
], function(declare,MappedAttributeId) {

	return declare(MappedAttributeId, {

		sourceClassName: "MaterialPlanPlacement",
		destinationClassNames: ["PartMaterial"]

	});
});
